import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  output,
} from '@angular/core';

import { AuthService } from '../../services/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-sign-out',
  imports: [],
  templateUrl: './sign-out.component.html',
  styleUrl: './sign-out.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignOutComponent implements OnInit {
  private readonly auth = inject(AuthService);

  public readonly signOutSuccess = output<void>();

  private readonly destroyRef = inject(DestroyRef);

  public ngOnInit(): void {
    this.auth
      .signOut()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => this.signOutSuccess.emit(),
      });
  }
}
